import React, { useState } from "react";

const initialState = {
  name: "",
  email: "",
  message: "",
};

export const Contact = (props) => {
  const [{ name, email, message }, setState] = useState(initialState);
  const [status, setStatus] = useState({ submitting: false, success: null, error: null });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setState((prevState) => ({ ...prevState, [name]: value }));
  };

  const clearState = () => setState({ ...initialState });

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus({ submitting: true, success: null, error: null });

    try {
      const response = await fetch("https://api.web3forms.com/submit", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify({
          access_key: process.env.REACT_APP_WEB3FORMS_KEY,
          subject: "New message from uajoshi.com",
          name,
          email,
          message,
          replyto: email,
          botcheck: "",
        }),
      });

      const result = await response.json();

      if (result.success) {
        clearState();
        setStatus({ submitting: false, success: "Message sent! I'll get back to you soon.", error: null });
      } else {
        setStatus({ submitting: false, success: null, error: result.message || "Something went wrong. Please try again." });
      }
    } catch (err) {
      setStatus({ submitting: false, success: null, error: err.message || "Failed to send. Please try again." });
    }
  };

  return (
    <div>
      <div id="contact">
        <div className="container">
          <div className="col-md-8">
            <div className="row">
              <div className="section-title">
                <h2>{props.data ? props.data.title : "Get In Touch"}</h2>
                <p>{props.data ? props.data.subtitle : ""}</p>
              </div>
              <form name="sentMessage" onSubmit={handleSubmit}>
                <input type="checkbox" name="botcheck" style={{ display: "none" }} />
                <div className="row">
                  <div className="col-md-6">
                    <div className="form-group">
                      <input
                        type="text"
                        id="name"
                        name="name"
                        className="form-control"
                        placeholder="Your name"
                        value={name}
                        required
                        onChange={handleChange}
                      />
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group">
                      <input
                        type="email"
                        id="email"
                        name="email"
                        className="form-control"
                        placeholder="Your email"
                        value={email}
                        required
                        onChange={handleChange}
                      />
                    </div>
                  </div>
                </div>
                <div className="form-group">
                  <textarea
                    name="message"
                    id="message"
                    className="form-control"
                    rows="5"
                    placeholder="Tell me about your project or question..."
                    value={message}
                    required
                    onChange={handleChange}
                  ></textarea>
                </div>

                {status.success && (
                  <div className="form-status form-status-success">
                    {status.success}
                  </div>
                )}
                {status.error && (
                  <div className="form-status form-status-error">
                    {status.error}
                  </div>
                )}

                <button
                  type="submit"
                  className="btn btn-custom btn-lg"
                  disabled={status.submitting}
                >
                  {status.submitting ? "Sending..." : "Send Message"}
                </button>
              </form>
            </div>
          </div>

          <div className="col-md-3 col-md-offset-1 contact-info">
            <h3>Contact Info</h3>
            <div className="contact-item">
              <p>
                <span>
                  <i className="fa fa-envelope-o"></i> Email
                </span>
                {props.data ? props.data.email : "loading"}
              </p>
            </div>
            <div className="contact-item">
              <p>
                <span>
                  <i className="fa fa-linkedin"></i> LinkedIn
                </span>
                {props.data ? (
                  <a href={props.data.linkedin} target="_blank" rel="noopener noreferrer">
                    Connect on LinkedIn
                  </a>
                ) : "loading"}
              </p>
            </div>
          </div>

          <div className="col-md-12">
            <div className="row">
              <div className="social">
                <ul>
                  <li>
                    <a href={props.data ? props.data.linkedin : "/"} target="_blank" rel="noopener noreferrer">
                      <i className="fa fa-linkedin"></i>
                    </a>
                  </li>
                  <li>
                    <a href={props.data ? props.data.twitter : "/"} target="_blank" rel="noopener noreferrer">
                      <i className="fa fa-twitter"></i>
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div id="footer">
        <div className="container text-center">
          <p>
            &copy; {new Date().getFullYear()} Udayan Joshi &mdash; Technology
            Architect &amp; Innovation Leader
          </p>
        </div>
      </div>
    </div>
  );
};
